import { render } from "./packageManagement.vue?vue&type=template&id=7351b5da&scoped=true"
import script from "./packageManagement.vue?vue&type=script&lang=js"
export * from "./packageManagement.vue?vue&type=script&lang=js"

import "./packageManagement.vue?vue&type=style&index=0&id=7351b5da&lang=scss&scoped=true"
import "./packageManagement.vue?vue&type=style&index=1&id=7351b5da&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7351b5da"]])

export default __exports__